import React, { useState, useEffect } from "react";
import { Table, Space } from "antd";
import "./bundleTransport.scss";

import { ToastContainer, toast } from "react-toastify";
import Spinner from "../common/spinner";
import { Col, Row } from "react-bootstrap";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getMapIdBasedonEnvironment, log } from "../../helper/helper";
import * as service from "./bundleTransportServices";
import origin from "../../assets/origin.png";
import destination from "../../assets/destination.png";
import {
  GoogleMap,
  Marker,
  Polyline,
  OverlayView,
} from "@react-google-maps/api";
import decodePolyline from "decode-google-map-polyline";

function BundleTransportSingle(props) {
  const [isLoading, setLoading] = useState(false);
  const [map, setMap] = useState(null);
  const [rightMapPositions, setRightMapPositions] = useState([]);
  const [leftMapPositions, setLeftMapPositions] = useState([]);

  const data = props.location.state.data;
  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (!user) {
        return props.history.replace("/login");
      }
    });

    const positionsLeftData = [];
    for (const trip of data.original_transport_details_for_admin) {
      positionsLeftData.push(
        {
          lat: trip.origin_lat,
          lng: trip.origin_lng,
          icon: origin,
          zIndex: 9,
        },
        {
          lat: trip.destination_lat,
          lng: trip.destination_lng,
          icon: destination,
          zIndex: 9,
        }
      );
    }
    setLeftMapPositions(positionsLeftData);

    const positionsRightData = data.bundled_path_with_delivery_action.map(
      (trip) => ({
        lat: trip.lat,
        lng: trip.lng,
        icon: trip.delivery_action === "pickup" ? origin : destination,
        zIndex: 9,
      })
    );
    setRightMapPositions(positionsRightData);
  }, [data]);

  const loadLeftGoogleMap = () => {
    return (
      <GoogleMap
        mapContainerStyle={containerStyle}
        zoom={13}
        onLoad={(mapInstance) => onLoadBounds(mapInstance, leftMapPositions)}
        onUnmount={onUnmount}
        defaultOptions={defaultMapOptions}
        options={{
          mapId: getMapIdBasedonEnvironment(),
        }}
      >
        {leftMapPositions.map((marker) => (
          <Marker
            position={marker}
            key={marker.lat + marker.lng + Math.random()}
            icon={{
              url: marker.icon,
            }}
          />
        ))}
        {data.original_transport_details_for_admin.map((trip, idx) => (
          <Polyline
            key={`polyline-${idx}`}
            path={decodePolyline(trip.overview_polyline)}
            options={options}
          />
        ))}
        <></>
      </GoogleMap>
    );
  };
  const loadRightGoogleMap = () => {
    return (
      <GoogleMap
        mapContainerStyle={containerStyle}
        zoom={13}
        onLoad={(mapInstance) => onLoadBounds(mapInstance, rightMapPositions)}
        onUnmount={onUnmount}
        defaultOptions={defaultMapOptions}
        options={{
          mapId: getMapIdBasedonEnvironment(),
        }}
      >
        {rightMapPositions.map((marker, idx) => (
          <React.Fragment key={marker.lat + marker.lng + idx}>
            <Marker
              position={marker}
              icon={{
                url: marker.icon,
              }}
            />

            <OverlayView
              position={{ lat: marker.lat, lng: marker.lng }}
              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            >
              <div className="marker-number-circle">{idx + 1}</div>
            </OverlayView>
          </React.Fragment>
        ))}

        <Polyline
          key={`polyline-x`}
          path={decodePolyline(data.overview_polyline)}
          options={options}
        />

        <></>
      </GoogleMap>
    );
  };
  const renderSpinner = () => (isLoading ? <Spinner /> : null);

  const onLoadBounds = (mapInstance, positions) => {
    if (!mapInstance) return;
    const bounds = new window.google.maps.LatLngBounds();
    positions.forEach((child) => {
      bounds.extend(new window.google.maps.LatLng(child.lat, child.lng));
    });
    mapInstance.fitBounds(bounds);
    setMap(mapInstance);
  };

  const defaultMapOptions = {
    fullscreenControl: true,
  };

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  const containerStyle = {
    width: "100%",
    height: "50vh",
  };

  const options = {
    fillColor: "lightblue",
    fillOpacity: 1,
    strokeColor: "blue",
    strokeOpacity: 1,
    strokeWeight: 2,
    clickable: false,
    draggable: false,
    editable: false,
    geodesic: false,
    zIndex: 1,
  };

  const columns = [
    {
      title: "#",
      render: (_, __, index) => index + 1,
      width: 60,
      align: "center",
    },
    {
      title: "Origin",
      dataIndex: "shortened_origin_address",
      key: "shortened_origin_address",
    },
    {
      title: "Destination",
      dataIndex: "shortened_destination_address",
      key: "shortened_destination_address",
    },
    {
      title: "Distance",
      dataIndex: "distance",
      key: "distance",
      align: "center",
    },
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
      align: "center",
    },
    {
      title: "Original Payable",
      dataIndex: "original_payable_to_rider",
      key: "original_payable_to_rider",
      align: "center",
      render: (text, record) => {
        const original = Number(record.original_payable_to_rider) || 0;
        const bundle = Number(record.bundle_single_order_price) || 0;
        const isHigher = original > bundle;
        const isLower = original < bundle;

        const bgColor = isLower ? "green" : isHigher ? "red" : "#fff";

        return (
          <div
            style={{
              borderRadius: "6px",
              padding: "4px 8px",
              display: "inline-block",
              color: bgColor,
            }}
          >
            {original.toFixed(2)} A$
          </div>
        );
      },
    },
    {
      title: "In Bundle Pays",
      dataIndex: "bundle_single_order_price",
      key: "bundle_single_order_price",
      align: "center",
      render: (text, record) => {
        const original = Number(record.original_payable_to_rider) || 0;
        const bundle = Number(record.bundle_single_order_price) || 0;
        const isHigher = bundle > original;
        const isLower = bundle < original;

        const bgColor = isLower ? "green" : isHigher ? "red" : "#fff";

        return (
          <div
            style={{
              borderRadius: "6px",
              padding: "4px 8px",
              display: "inline-block",
              color: bgColor,
            }}
          >
            {bundle.toFixed(2)} A$
          </div>
        );
      },
    },
  ];

  const cancelBundleIds = async () => {
    setLoading(true);
    try {
      const result = await service.adminUnlockTransportForArrangmentBundled(
        data.bundled_id,
        data.transports
      );
      log(result);
      if (result) {
        setLoading(false);
        switch (result.data.code) {
          case 200:
            props.history.goBack();
            return;
          case 401:
            toast.error(result.data.message);
            return props.history.replace("/login");
          case 500:
            return toast.error(result.data.message);
          default:
            return toast.error(result.data.message);
        }
      }
    } catch (error) {
      log(error);
      toast.error(error.message);
    }
    setLoading(false);
  };

  return (
    <div className="table-design car-list-history show-all-list bundle-transport ">
      <ToastContainer />
      {renderSpinner()}
      {rightMapPositions.length > 0 && leftMapPositions.length > 0 && (
        <Row>
          <Col md={6}>
            <h5 style={{ textAlign: "left", margin: "10px 0" }}>
              Single Order Routes
            </h5>
            <div className="map">{loadLeftGoogleMap()}</div>
          </Col>
          <Col md={6}>
            <h5 style={{ textAlign: "left", margin: "10px 0" }}>
              Bundled Order Route
            </h5>
            <div className="map">{loadRightGoogleMap()}</div>
          </Col>
        </Row>
      )}
      <Table
        columns={columns}
        dataSource={data.original_transport_details_for_admin}
        pagination={false}
        rowKey={(_, index) => index}
        bordered
        style={{ margin: "20px 0 " }}
        summary={(pageData) => {
          const totalOriginalPayable = pageData.reduce(
            (sum, row) => sum + (Number(row.original_payable_to_rider) || 0),
            0
          );
          const totalBundlePays = pageData.reduce(
            (sum, row) => sum + (Number(row.bundle_single_order_price) || 0),
            0
          );

          return (
            <Table.Summary.Row>
              <Table.Summary.Cell index={0} colSpan={5} align="right">
                Total
              </Table.Summary.Cell>

              <Table.Summary.Cell index={1} align="center">
                <span
                  style={{
                    color: "white",
                    padding: "5px",
                    borderRadius: "4px",
                    backgroundColor:
                      totalOriginalPayable < totalBundlePays
                        ? "green"
                        : totalOriginalPayable > totalBundlePays
                          ? "red"
                          : "black",
                    fontWeight: "bold",
                  }}
                >
                  {totalOriginalPayable.toFixed(2)} A$
                </span>
              </Table.Summary.Cell>

              <Table.Summary.Cell index={2} align="center">
                <span
                  style={{
                    color: "white",
                    padding: "5px",
                    borderRadius: "4px",
                    backgroundColor:
                      totalBundlePays < totalOriginalPayable
                        ? "green"
                        : totalBundlePays > totalOriginalPayable
                          ? "red"
                          : "black",
                    fontWeight: "bold",
                  }}
                >
                  {totalBundlePays.toFixed(2)} A$
                </span>
              </Table.Summary.Cell>
            </Table.Summary.Row>
          );
        }}
      />

      <div className="extra-info">
        <Space.Compact block>
          <div className="title">Total Travelling Distance: </div>
          <div className="value">{data.bundle_length}</div>
        </Space.Compact>
        <Space.Compact block>
          <div className="title">Total Driving Time: </div>
          <div className="value">{data.bundle_duration} min</div>
        </Space.Compact>
        <Space.Compact block>
          <div className="title">Total Time to Complete:</div>
          <div className="value">{data.bundle_time}</div>
        </Space.Compact>
        <Space.Compact block>
          <div className="title">Starting Address:</div>
          <div className="value">{data.shortened_first_origin_address}</div>
        </Space.Compact>
        <Space.Compact block>
          <div className="title">Ending Address:</div>
          <div className="value">{data.shortened_last_destination_address}</div>
        </Space.Compact>
      </div>

      <div className="load-more">
        <ul style={{ margin: "20px 0" }}>
          <li style={{ display: "inline-block" }}>
            <button onClick={() => cancelBundleIds()}>Cancel & Unlock</button>
          </li>
          <li style={{ display: "inline-block" }}>
            <button onClick={() => props.history.goBack()}>
              Finish & Close
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default BundleTransportSingle;
